import React, { useState } from 'react';
import axios from 'axios';
import { API } from "../api";
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(API + '/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setSent(true); // On affiche quand même le succès pour ne pas révéler les emails
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f5f5f5' }}>
      <div style={{ background: '#fff', padding: 32, borderRadius: 12, border: '1px solid #e0e0e0', width: 320 }}>
        <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 8, textAlign: 'center' }}>📅 Congés+</div>
        <div style={{ fontSize: 13, color: '#888', marginBottom: 24, textAlign: 'center' }}>Mot de passe oublié</div>

        {sent ? (
          <div>
            <div style={{ background: '#EAF3DE', color: '#3B6D11', padding: '12px 14px', borderRadius: 8, fontSize: 13, marginBottom: 20 }}>
              Si cet email existe, un lien de réinitialisation vous a été envoyé. Vérifiez votre boîte mail.
            </div>
            <button onClick={() => navigate('/login')}
              style={{ width: '100%', padding: 10, background: '#185FA5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 500, cursor: 'pointer' }}>
              Retour à la connexion
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>Votre adresse email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                style={{ width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' }} />
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: 10, background: loading ? '#ccc' : '#185FA5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 500, cursor: loading ? 'default' : 'pointer', marginBottom: 12 }}>
              {loading ? 'Envoi...' : 'Envoyer le lien'}
            </button>
            <button type="button" onClick={() => navigate('/login')}
              style={{ width: '100%', padding: 10, background: 'none', color: '#888', border: '1px solid #ddd', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}>
              Retour
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
